import PropTypes from "prop-types";
import TextButton from "@shared/v2/TextButton";
import goToLeadView from "../BusinessDashboard/helpers/goToLeadView";

const getClassFromValue = (value, size) => {
  if (value > 999999) return size === "small" ? "tw-text-[10px]" : "tw-text-12d";
  if (value > 99999) return size === "small" ? "tw-text-12d" : "tw-text-14d";
  return size === "small" ? "tw-text-14d" : "tw-text-18d";
};

const InnerRing = ({ agentId, filters, goal, value, title, dateRange, size }) => {
  const hasGoal = goal > 0;
  const valueClass = getClassFromValue(value, size);
  const goalClass = getClassFromValue(goal, size);
  return (
    <div className="tw-group tw-absolute tw-inset-0 tw-flex tw-justify-center tw-items-center tw-text-10">
      <div
        className={`tw-flex tw-flex-col tw-gap-[2px] ${hasGoal ? "group-hover:tw-hidden" : ""} tw-text-center`}
      >
        <span className={valueClass}>{value.toLocaleString()}</span>
        <hr className="tw-m-0" />
        {hasGoal && <span className={`${goalClass} tw-text-gray-50`}>{goal.toLocaleString()}</span>}
        {!hasGoal && (
          <TextButton
            onClick={() => window.open("/settings/goals", "_blank")}
            className={size === "small" ? "tw-text-[9px]" : ""}
          >
            Set Goal
          </TextButton>
        )}
      </div>
      {hasGoal && (
        <TextButton
          className={`tw-hidden group-hover:tw-block ${size === "small" ? "tw-text-[9px]" : ""}`}
          onClick={() => goToLeadView({ agentId, filters, title, dateRange })}
        >
          View
        </TextButton>
      )}
    </div>
  );
};

InnerRing.propTypes = {
  agentId: PropTypes.number,
  filters: PropTypes.shape().isRequired,
  goal: PropTypes.number,
  value: PropTypes.number,
  title: PropTypes.string.isRequired,
  dateRange: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium"]),
};

InnerRing.defaultProps = {
  agentId: undefined,
  goal: 0,
  value: 0,
  size: "medium",
};

export default InnerRing;
